import { GetAllNetworks, PLATFORM_ROUTE, authPages } from "../../../components/helpers";
import AuthPage from "../../../components/pages/platform/AuthPage";
import React from "react";
import { APILogin } from "../../../components/APILogin";
import { CreateGroup } from "../../../components/CreateGroup";
import router from "next/router";
import PageLoad from "../../../components/PageLoad";
// import { MagicLogin } from "../../../components/MagicLogin";
import { ApiSignup } from "../../../components/APISignup";
import Layout from "../../../components/layouts/PlatformLayout";
import Head from "next/head";


export default function LP({ authRequired, slug, busy, networks, title, user, setUser, token, setToken, handleToast, visitor, adBlock }) {

    const isLoggedIn = !authRequired ? true : user.match({
        None: () => false,
        Some: () => true
    });


    if (busy) {
        return <PageLoad />;
    }
    
    if (slug === "create_group") {

        const hasGroup = user.match({
            None: () => false,
            Some: (user) => user.group ? true : false
        });
        if (hasGroup) {
            router.replace(`/${PLATFORM_ROUTE}`);
            return;
        }
        return <Layout user={user}><AuthPage user={user} busy={busy} isLoggedIn={isLoggedIn} title={title} networks={networks} slug={slug}>
            <CreateGroup setToken={setToken} handleToast={handleToast} user={user} token={token} setUser={setUser} />
        </AuthPage></Layout>;

    } else if (slug === "register") {
        return <><Head>
            <link
                rel="canonical"
                href={`https://www.covalenthq.com/platform/auth/register/`}
                key="canonical"
            />
        </Head><Layout user={user}><AuthPage noAuth user={user} busy={busy} isLoggedIn={isLoggedIn} title={title} networks={networks} slug={slug}>
            <ApiSignup adBlock={adBlock} handleToast={handleToast} pageType={"platform"} visitor={visitor} />
        </AuthPage></Layout></>;
    }
    else if (slug === "login") {
        return user.match({
            None: () => {
                return <><Head>
                    <link
                        rel="canonical"
                        href={`https://www.covalenthq.com/platform/auth/login/`}
                        key="canonical"
                    />
                </Head><Layout user={user}><AuthPage noAuth user={user} busy={busy} isLoggedIn={isLoggedIn} title={title} networks={networks} slug={slug}>
                    <APILogin adBlock={adBlock} setUser={setUser} setToken={setToken} visitor={visitor} handleToast={handleToast} />
                </AuthPage></Layout></>;
            },
            Some: () => {
                router.replace(`/${PLATFORM_ROUTE}`);
                return;
            }
        });
    } else {
        return <div>404</div>;
    }
}

export async function getStaticProps({ params }) {
    const needsNetworks = params.slug === "login" || params.slug === "register";
    const networks = needsNetworks && await GetAllNetworks();

    return {
        props: {
            authRequired: authPages.filter((page) => page.slug === params.slug)[0].authRequired,
            slug: params.slug,
            networks,
            component: "Platform",
            title: authPages.filter((page) => page.slug === params.slug)[0].title,
        },
    };
}

export async function getStaticPaths() {
    return {
        paths: authPages.map((page) => { return { params: { slug: page.slug } }; }),
        fallback: false,
    };
}
